import { Toaster } from 'sonner';
import { useTheme } from '@/lib/theme.js';

/** Sonner wrapper that follows our resolved theme. */
export function AppToaster(): JSX.Element {
  const { resolved } = useTheme();
  return <Toaster theme={resolved} position="top-right" richColors closeButton />;
}
